import { Package, Shirt, type LucideIcon } from 'lucide-react';
import type { ComposerSkillId } from '@/lib/api/skills';

export interface ComposerSkillPresentation {
  labelKey: string;
  descriptionKey: string;
  icon: LucideIcon;
  previewImage: string;
  previewVideo?: string;
}

export type VisibleComposerSkillId = Exclude<ComposerSkillId, 'brand-visual-video'>;

export const DEFAULT_COMPOSER_SKILL_IDS: VisibleComposerSkillId[] = process.env.NEXT_PUBLIC_AI_GENERATION_MARKET === 'domestic' ? [
  'ugc-bag-unboxing',
  'ugc-beauty-skincare',
  'ugc-try-on',
] : [];

export const COMPOSER_SKILL_PRESENTATION: Record<VisibleComposerSkillId, ComposerSkillPresentation> = {
  'ugc-bag-unboxing': {
    labelKey: 'skillWorkflowUgcBagUnboxing',
    descriptionKey: 'skillWorkflowUgcBagUnboxingDescription',
    icon: Package,
    previewImage: '/media-previews/v1/covers/ugc-bag-unboxing.jpg',
    previewVideo: '/media-previews/v1/videos/ugc-bag-unboxing.mp4',
  },
  'ugc-beauty-skincare': {
    labelKey: 'skillWorkflowUgcBeautySkincare',
    descriptionKey: 'skillWorkflowUgcBeautySkincareDescription',
    icon: Package,
    previewImage: '/media-previews/v1/covers/ugc-beauty-skincare.jpg',
    previewVideo: '/media-previews/v1/videos/ugc-beauty-skincare.mp4',
  },
  'ugc-try-on': {
    labelKey: 'skillWorkflowUgcTryOn',
    descriptionKey: 'skillWorkflowUgcTryOnDescription',
    icon: Shirt,
    previewImage: '/media-previews/v1/covers/ugc-try-on.jpg',
    previewVideo: '/media-previews/v1/videos/ugc-try-on.mp4',
  },
};

export function isVisibleComposerSkillId(
  skillId: ComposerSkillId,
): skillId is VisibleComposerSkillId {
  return process.env.NEXT_PUBLIC_AI_GENERATION_MARKET === 'domestic' && skillId !== 'brand-visual-video';
}
